<div class="row mx-auto item border-bottom align-items-center"
  [ngClass]="{'clickable': fsItem.isFolder}"
  (click)="onItemClick()">

  <div class="col-1">
    <mat-icon *ngIf="fsItem.isFolder">folder</mat-icon>
    <mat-icon *ngIf="!fsItem.isFolder"
      [matTooltip]="fsItem.filePath">insert_drive_file</mat-icon>
  </div>

  <div class="col-8 text-truncate flex-grow-0"
    *ngIf="fsStore.configuration?.listColumns?.name"
    [ngClass]="fsStore.configuration?.listColumns?.name"
    matTooltip="{{fsItem.name}}">
    {{fsItem.name}}
  </div>

  <div class="col-3 text-truncate"
    *ngIf="fsStore.configuration?.listColumns?.createdBy"
    [ngClass]="fsStore.configuration?.listColumns?.createdBy"
    matTooltip="{{fsItem.createdBy}}">
    {{fsItem.createdBy}}
  </div>

  <div class="col-3 text-truncate"
    *ngIf="fsStore.configuration?.listColumns?.modifiedBy"
    [ngClass]="fsStore.configuration?.listColumns?.modifiedBy"
    matTooltip="{{fsItem.modifiedBy}}">
    {{fsItem.modifiedBy}}
  </div>

  <div class="col-2"
    *ngIf="fsStore.configuration?.listColumns?.created"
    [ngClass]="fsStore.configuration?.listColumns?.created">
    {{fsItem.created | date}}
  </div>

  <div class="col-2"
    *ngIf="fsStore.configuration?.listColumns?.modified"
    [ngClass]="fsStore.configuration?.listColumns?.modified">
    {{fsItem.modified | date}}
  </div>

  <div class="col-3 text-truncate"
    *ngIf="fsStore.configuration?.listColumns?.tags"
    [ngClass]="fsStore.configuration?.listColumns?.tags">
    <ng-container
      *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
      <span matTooltip="{{fsItem.tagsList}}">
        <span *ngFor="let tag of fsItem.tags;let last = last">
          {{tag.value}}<span *ngIf="!last">, </span>
        </span>
      </span>
    </ng-container>
  </div>

  <div class="col-1 d-flex align-items-end"
    *ngIf="fsStore.configuration?.listColumns?.actions"
    [ngClass]="fsStore.configuration?.listColumns?.actions">
    <prada-fs-actions [fsItem]="fsItem"
      [fsStore]="fsStore"
      (fsItemActionClick)="onFsItemActionClick($event)"></prada-fs-actions>
  </div>
</div>